import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";
import { usePageContent } from "../lib/pageContent";

export const Footer = () => {
  const c = usePageContent();
  const tagline = c?.footer_tagline ||
    "Personalized health & nutrition guidance, expert video lessons, and downloadable PDF guides to help you build a healthier, calmer life.";
  return (
  <footer className="bg-cardm border-t border-subtle" data-testid="site-footer">
    <div className="container-page py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2 mb-4">
          <span className="w-9 h-9 rounded-full bg-moss text-white grid place-items-center"><Leaf size={18} /></span>
          <span className="font-heading text-xl font-semibold">Danashakaa.com</span>
        </div>
        <p className="text-sm text-muted2 max-w-md leading-relaxed">
          {tagline}
        </p>
      </div>
      <div>
        <h4 className="text-sm font-semibold text-ink mb-3">Platform</h4>
        <ul className="space-y-2 text-sm text-muted2">
          <li><Link to="/" className="hover:text-moss">Home</Link></li>
          <li><a href="/#about" className="hover:text-moss">About Dana</a></li>
          <li><a href="/#how-it-works" className="hover:text-moss">How it works</a></li>
          <li><a href="/#faq" className="hover:text-moss">FAQ</a></li>
        </ul>
      </div>
      <div>
        <h4 className="text-sm font-semibold text-ink mb-3">Account</h4>
        <ul className="space-y-2 text-sm text-muted2">
          <li><Link to="/login" className="hover:text-moss">Login</Link></li>
          <li><Link to="/register" className="hover:text-moss">Register</Link></li>
          <li><Link to="/forgot-password" className="hover:text-moss">Forgot password</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-subtle">
      <div className="container-page py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-soft">
        <span>© {new Date().getFullYear()} Danashakaa.com. All rights reserved.</span>
        <span>Made with care for your wellness.</span>
      </div>
    </div>
  </footer>
  );
};
